<script setup lang="ts">
import Tabbar from '@/components/Tabbar.vue';
import router from '@/router';
import _service from '@/service';
import { Cell, IndexAnchor, IndexBar, closeToast, showLoadingToast, showToast } from 'vant';
import { reactive } from 'vue';
import countryJson from '@/assets/country.json'
import {Verify} from './Verifition/index'
import { onMounted } from 'vue';
import { ref } from 'vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CountryCodeSlider from '@/components/CountryCodeSlider.vue';
const showSlider = ref<boolean>(false)
const alphabetArray = ref<any>([])
const searchWord = ref<string>('')
const timeCount = ref<number>(0)
const {t} = useI18n()
const verify = ref()
const captchaType = ref('blockPuzzle') // blockPuzzle 滑块 clickWord 点击文字


const form = reactive({
  mobile: '',
  regionCode: '',
  code:'', 
})

const loginFn = async () => {
  if (!form.mobile) {
    showToast('请填写手机号')
    return false
  }
  if (!form.code) {
    showToast('请填写验证码')
    return false
  }
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    const res: any = await _service.specialLogin({
      ...form
    })
    closeToast()
    if (!res.data) {
      showToast(res.msg)
      return
    }
    sessionStorage.setItem('APLINK_STARNEST_TOKEN', res.data.accessToken)
    localStorage.setItem('APLINK_STARNEST_TOKEN', res.data.accessToken)
    router.back()

  } catch (error) {

  }
}


onMounted(() => {

  // 创建一个包含二十六个英文字母的数组
  const _arr = Array.from(Array(26), (_, i) => String.fromCharCode('A'.charCodeAt(0) + i));
  alphabetArray.value = _arr

})

const countryList = computed((item: any) => {
  if (searchWord.value) {
    const _arr = countryJson.filter((item: any) => {
      if (`${item.name_en}${item.name_cn}${item.country_code}`.includes(searchWord.value)) {
        return item
      }
    })
    return _arr
  } else {
    return countryJson
  }

})

const getCountryCode = (code: string) => {
  form.regionCode = code
  showSlider.value = false
}

const getCaptcha = async () => {
  if (!form.regionCode) {
    showToast('请选择国家/地区')
    return false
  }
  if (!form.mobile) {
    showToast('请输入手机号')
    return false
  }
  console.log(verify.value,'value');
  
  verify.value.show()
}

const getSmsCode = async (data:any) => {
  try {
    const res:any = await _service.getSmsCode({
      ...form,
      mobileRegionCode:form.regionCode,
      smsType:"create",
      data,
    })
    if (res.data === true) {
      timeCount.value = 60
      const timer = setInterval(()=>{
        if (timeCount.value > 0) {
          timeCount.value --
        }else{
          clearInterval(timer)
        }
      },1000)
      showToast('已发送验证码')
    }else{
      showToast('发送验证码失败')
    }
  } catch (error) {
    showToast(`${error}`)
  }
}


</script>

<template>
  <div class="login-layout">
    <div class="media-375">
      <Tabbar title="登录" :back="false"></Tabbar>
      <div class="login-row flex-col-start-start">
        <div class="name">手机号</div>
        <div class="inputer">
          <span class="code" @click="showSlider = true">
            <span class="text">{{ form.regionCode ? `+${form.regionCode}` : '地区' }}</span> <i class="drop-down-icon"></i> </span>
          <input type="number" placeholder="请输入手机号" v-model="form.mobile" @input="(e: any) => {
            const validPattern = /^[0-9]*$/;
            if (!validPattern.test(e.target.value)) {
              e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }
          }">
        </div>
      </div>
      <div class="login-row flex-col-start-start">
        <div class="inputer">
          <input type="text" placeholder="请输入验证码" v-model="form.code"> <span class="text"  @click="getCaptcha" :class="{'disabled':!form.regionCode || !form.mobile}">{{ timeCount ? `${timeCount}s` : '获取验证码' }}</span>
        </div>
      </div>
      <div class="login-btn" @click="loginFn">登录</div>
    </div>
    <CountryCodeSlider @selectCode="getCountryCode" v-model:is-show="showSlider"></CountryCodeSlider>
    <Verify
      ref="verify"
      :captchaType="captchaType"
      :imgSize="{ width: '300px', height: '150px' }"
      mode="pop"
      @success="getSmsCode"
    />
  </div>
</template>

<style lang="scss" scoped>
.login-layout {
  height: 100%;
  min-height: 100vh;
  background: #000;
  padding: 0 12px;

  .login-row {
    gap: 10px;
    margin-top: 10px;

    .name {
      color: #9C9CAA;
      font-size: 12px;
    }

    .inputer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 48px;
      border-radius: 8px;
      background: #1F212D;
      padding: 12px;
      color: #1CF2E4;
      font-size: 14px;

      .text {
        width: 100px;
        cursor: pointer;
        text-align: right;
        &.disabled{
          pointer-events: none;
          opacity: 0.6;
        }
      }

      .code {
        position: relative;
        color: #fff;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 500;
        margin-right: 15px;

        .text {
          width: max-content;
        }

        &::after {
          display: block;
          content: "";
          width: 1px;
          height: 18px;
          background: rgba(255, 255, 255, 0.10);
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        .drop-down-icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../assets/drop-down-icon.svg);
          background-size: contain;
          background-repeat: no-repeat;
          margin-right: 4px;
        }
      }

    }

    input {
      width: 100%;
      height: 100%;
      background: #1F212D;
      font-size: 16px;
      color: #fff;
      &::placeholder {
        color: #565662;
      }
    }
  }

  .login-btn {
    display: flex;
    width: 100%;
    height: 48px;
    padding: 12px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 12px;
    background: linear-gradient(111deg, #FFF853 4.98%, #6EEF94 56.05%, #2AD8CD 95.37%);
    font-size: 16px;
    color: #070B14;
    font-weight: 500;
    margin: 0 auto;
    margin-top: 100px;
  }
}
</style>
